import { AssignedConsultant } from '../MyLom/Account/ConsultantAssignment/Types';

export function fetchAssignedConsultans(
    onSuccess: (consultants: AssignedConsultant[]) => void,
    onError: (json: any) => void,
    onFailure?: (error: any) => void,
) {
    fetch('/api/account/consultants', {
        method: 'get',
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while fetching assigned consultants: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}

export type ConsultantFetchAction = (
    consultantId: string,
    onSuccess: (consultants: AssignedConsultant[]) => void,
    onError: (json: any) => void,
    onFailure?: (error: any) => void,
) => void;

export const removeConsultant: ConsultantFetchAction = (consultantId, onSuccess, onError, onFailure) => {
    fetch('/api/account/consultant/remove', {
        method: 'PUT',
        body: JSON.stringify({ consultantId }),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while removing consultant: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
};

export const addConsultant: ConsultantFetchAction = (consultantId, onSuccess, onError, onFailure) => {
    fetch('/api/account/consultant/add', {
        method: 'POST',
        body: JSON.stringify({ consultantId }),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while removing consultant: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
};

export const toggleDefaultConsultant: ConsultantFetchAction = (consultantId, onSuccess, onError, onFailure) => {
    fetch('/api/account/consultant/toggleDefault', {
        method: 'PUT',
        body: JSON.stringify({ consultantId }),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while toggling default consultant: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
};

export const confirmConsultant: ConsultantFetchAction = (consultantId, onSuccess, onError, onFailure) => {
    fetch('/api/account/consultant/confirm', {
        method: 'POST',
        body: JSON.stringify({ consultantId }),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while confirming consultant: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
};

export const rejectConsultant: ConsultantFetchAction = (consultantId, onSuccess, onError, onFailure) => {
    fetch('/api/account/consultant/reject', {
        method: 'POST',
        body: JSON.stringify({ consultantId }),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.errors) {
                onError(json.errors);
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error) => {
            console.error('Server failure while confirming consultant: ', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
};
